// Label Color constant which is used in graph charts
export const LABEL_COLOUR = '#666';

// Default series item colour
export const DEFAULT_SERIES_ITEM_COLOUR = '#9e9d9d';

// Major Grid Lines
export const MAJOR_GRID_LINES = {
  visible: true,
  color: '#e0e0e0',
  width: 1,
};
